import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Panel, Stat, SandboxNotice, fmtMoney } from "@/components/Peep";
import { IntegrationAlertBanner } from "@/components/IntegrationHealth";

export default function AdminOverview() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/overview").then((r) => setD(r.data)).catch(() => {});
  }, []);
  if (!d) return <p className="text-sm text-[#a7a0af]">Loading…</p>;
  return (
    <div data-testid="admin-overview" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">Platform overview</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">Every creator, membership and ledger entry across PEEPING.</p>
      </div>
      <IntegrationAlertBanner />
      <SandboxNotice />
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Stat label="Active creators" value={`${d.creators.active} / ${d.max_active_creators}`} testid="ov-creators-active" />
        <Stat label="Invited / suspended" value={`${d.creators.invited} / ${d.creators.suspended}`} />
        <Stat label="Subscribers" value={d.subscribers} testid="ov-subscribers" />
        <Stat label="Past due" value={d.past_due} />
        <Stat label="Creator memberships" value={d.active_memberships.creator} testid="ov-creator-subs" />
        <Stat label="All Access" value={d.active_memberships.all_access} testid="ov-aa-subs" />
        <Stat label="Gross revenue" value={fmtMoney(d.platform.gross)} testid="ov-gross" />
        <Stat label="Unallocated bundle" value={fmtMoney(d.unallocated_bundle.gross + 0)} />
      </div>
      <Panel title="Next steps">
        <ul className="flex flex-col gap-2 text-sm text-[#c7c1cf]">
          <li>1. <Link className="text-[#d42be8]" to="/admin/creators">Invite your creators (up to 50)</Link> — they set their own passwords.</li>
          <li>2. <Link className="text-[#d42be8]" to="/admin/pricing">Set membership prices</Link> — a membership stays unpurchasable until its price is set.</li>
          <li>3. Configure bundle allocation and platform fee only once you've decided them (both stay unset by default).</li>
          <li>4. <Link className="text-[#d42be8]" to="/admin/provider">Review payment-provider eligibility</Link> and approve one.</li>
        </ul>
      </Panel>
    </div>
  );
}
